import { useTranslation } from 'react-i18next';

import { setAdminLocale } from '../i18n';
import { AVAILABLE_UI_LOCALES, LOCALE_LABELS, type UiLocale } from '../i18n/supportedLocales';
import './LanguageSwitcher.css';

/**
 * Dil değiştirici — AppShell header'ında. Liste `AVAILABLE_UI_LOCALES`'ten
 * türetilir (çevirisi olmayan dil menüye HİÇ düşmez); etiketler dilin KENDİ
 * adıyla (endonym) — kullanıcı anlamadığı bir arayüzde bile kendi dilini
 * bulabilmeli. Kalıcı yazma tek yerde: `i18n/index.ts#setAdminLocale`.
 */
export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const base = i18n.language.split('-')[0] ?? 'tr';
  const current = (AVAILABLE_UI_LOCALES as readonly string[]).includes(base) ? (base as UiLocale) : 'tr';

  return (
    <div className="language-switcher" role="group" aria-label="Language">
      {AVAILABLE_UI_LOCALES.map((locale) => (
        <button
          key={locale}
          type="button"
          title={LOCALE_LABELS[locale]}
          className={
            'language-switcher__option' + (current === locale ? ' language-switcher__option--active' : '')
          }
          onClick={() => setAdminLocale(locale)}
        >
          {locale.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
